import * as React from 'react';

function Video({ videoUrl, credit, creditTemplate, locution }) {
  return (
    <div id="boxInformacoes" className="bundleTela">
      <div className="video-container">
        <video
          id="video"
          autoPlay
          controls
          src={videoUrl}
          type="video/mp4"
          className="video-elm"
        />
      </div>

      <div className="video-credits">
        <p className="credits-title">Créditos do vídeo:</p>
        <p>Criação do vídeo: {creditTemplate}</p>
        <p>Locução: {locution}</p>
        <p>Renderização: {credit}</p>
      </div>
    </div>
  );
}

export default Video;